<template>
  <div class="quill-editor">
    <slot>
      <div v-html="data"></div>
    </slot>
  </div>
</template>

<script>
import Quill from 'quill'
import { htmlEditButton } from "./quill.htmlEditButton.js";
// var Size = Quill.import('attributors/style/size');
// Quill.register(Size, true);
// Size.whitelist = ['14px', '16px', '18px'];
var Link = Quill.import('formats/link');

class MyLink extends Link {
  static create (value) {
    let node = super.create(value);
    value = this.sanitize(value);
    if (!value.startsWith("http")) {
      value = "http://" + value;
    }
    node.setAttribute('href', value);
    return node;
  }
}

Quill.register(MyLink);

Quill.register("modules/htmlEditButton", htmlEditButton);

var Parchment = Quill.import('parchment');
var BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
  'alt',
  'height',
  'width',
  'style',
  'title'
];

class ImageFormat extends BaseImageFormat {
  static formats (domNode) {
    return ImageFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format (name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(ImageFormat, true);
export default {

  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    autofocus: Boolean,
    data: String

  },

  data () {
    return {
      focused: this.autofocus,
      editor: null,

    }
  },

  mounted () {
    this.editor = new Quill(this.$el, this.options)
    this.editor.root.innerHTML = this.data ? this.data : ''

  },

  watch: {
    focused (val) {
      this.editor[val ? 'focus' : 'blur']()
    }
  }

}
</script>

<style lang="styl">
@import "~quill/assets/snow";
.notExpand .quill-editor .ql-editor {
  height: 400px !important;
}
</style>
